import React from 'react';

const PrivacyPolicyPage = () => {
  return (
    <div style={{ padding: '20px', fontFamily: 'sans-serif', lineHeight: '1.6' }}>
      <h2>Privacy Policy</h2>
      <p><strong>Last updated on April 06, 2025</strong></p>

      <p>
        At <strong>CIRAYEDAAR</strong>, we value your trust and are committed to protecting your privacy. This Privacy Policy outlines how we collect, use, disclose, and safeguard your personal information when you visit our website or use our services.
      </p>

      <h3>1. Information We Collect</h3>
      <p>When you interact with our website or contact us for services, we may collect the following types of information:</p>
      <ul>
        <li><strong>Personal Information:</strong> Name, contact number, email address, postal address, and other details you voluntarily provide.</li>
        <li><strong>Usage Data:</strong> IP address, browser type, device information, pages visited, and time spent on our website.</li>
        <li><strong>Communication Records:</strong> Any feedback, queries, or concerns you share via email, phone, or forms.</li>
      </ul>

      <h3>2. How We Use Your Information</h3>
      <ul>
        <li>Provide, operate, and maintain our services</li>
        <li>Improve user experience and our website offerings</li>
        <li>Respond to your queries or service requests</li>
        <li>Comply with legal obligations</li>
      </ul>
      <p>We do not sell or rent your personal information to third parties for marketing purposes.</p>

      <h3>3. Cookies and Tracking Technologies</h3>
      <p>
        Our website may use cookies to enhance your browsing experience. These are small files stored on your device that help us analyze traffic and usage patterns. You can disable cookies in your browser settings, though it may affect site functionality.
      </p>

      <h3>4. Data Sharing and Disclosure</h3>
      <p>We may share your information with:</p>
      <ul>
        <li><strong>Service Providers</strong> who assist in website operations under strict confidentiality</li>
        <li><strong>Legal Authorities</strong> when required under applicable laws or regulations</li>
        <li><strong>Affiliates or Partners</strong> strictly for the purpose of fulfilling your service request</li>
      </ul>

      <h3>5. Data Security</h3>
      <p>
        We take appropriate technical and organizational measures to secure your data from unauthorized access, loss, or misuse. However, no method of transmission over the Internet is 100% secure.
      </p>

      <h3>6. Links to Other Websites</h3>
      <p>
        Our website may contain links to external sites. We are not responsible for the privacy practices or content of those sites and encourage you to review their policies independently.
      </p>

      <h3>7. Your Consent</h3>
      <p>
        By using our website, you consent to our Privacy Policy and the collection and use of your information as described.
      </p>

      <h3>8. Changes to This Policy</h3>
      <p>
        We reserve the right to update or change our Privacy Policy at any time. Any changes will be posted on this page with an updated revision date.
      </p>

      <h3>9. Contact Us</h3>
      <p>If you have any questions or concerns regarding this Privacy Policy or the protection of your data, you can reach us at:</p>
      <p>
        <strong>CIRAYEDAAR</strong><br />
        Flat no 1, Khalsa Tent House Wali Gali,<br />
        Kamalpur, Aligarh, UTTAR PRADESH 202001<br />
        Email: <em>support@cirayedaar.com</em><br />
        Phone: <em>+91 7817833477</em>
      </p>
    </div>
  );
};

export default PrivacyPolicyPage;
